import { IConfig } from '@cian/config/shared';

export const isSendUserModifiedSuggestionsEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.SendUserModifiedSuggestions.Enabled'));
};
